import type { BranchUser } from '../@types/BranchUser';
import type { Actions } from '../actions';
import { REQ_BRANCH } from '../actions/branch';
import {
  RCV_CREATE_BRANCH_USER,
  RCV_REMOVE_BRANCH_USER,
  RCV_USER_LIST,
  REQ_CREATE_BRANCH_USER,
  REQ_REMOVE_BRANCH_USER,
  REQ_USER_LIST,
  REQUEST_FAILED,
} from '../actions/branch-user';
import { requestStatus, responseStatus } from '../shared/statuses';

interface BranchUsersState {
  requestStatus: number;
  responseStatus: number;
  list: BranchUser[];
}

const _initialState: BranchUsersState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  list: [],
};

const usersReducer = (
  state: BranchUsersState = _initialState,
  action: Actions,
): BranchUsersState => {
  let list = null;

  switch (action.type) {
    case REQ_USER_LIST:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_USER_LIST:
      return {
        ...state,
        list: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_CREATE_BRANCH_USER:
      return {
        ...state,
        requestStatus: requestStatus.CREATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_CREATE_BRANCH_USER:
      list = state.list.slice();
      list.push(action.response);

      return {
        ...state,
        list,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_REMOVE_BRANCH_USER:
      return {
        ...state,
        requestStatus: requestStatus.REMOVING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_REMOVE_BRANCH_USER: {
      list = state.list.slice();
      const index = list.findIndex((u) => u.id === action.response.id);

      if (index >= 0) {
        list.splice(index, 1);
      }

      return {
        ...state,
        list,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    }
    case REQ_BRANCH:
      return { ...state, list: [] };
    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default usersReducer;
